import { getFirestore, collection, doc, getDoc, getDocs, updateDoc, addDoc, setDoc, query, where, orderBy, limit, startAfter, endBefore, onSnapshot, startAt } from "firebase/firestore";
import Vue from "vue";
import Axios from "axios";
import VueAxios from "vue-axios";
import moment from 'moment';
import { requestEndPoint } from '@/store/Api'

const db = getFirestore();

Vue.use(VueAxios, Axios);
export default {
    state: {
        feedbackList: [],
        unsubscribeGetFeedbackList: null,
        subscribedFeedbackList: false,
        feedbackNotifications: [],
        unsubscribeGetFeedbackNotifications: null,
        subscribedFeedbackNotifications: false,
        feedbackListForBadge: [],
        unsubscribeGetFeedbackListForBadge: null,
        subscribedFeedbackListForBadge: false,
        feedbackListWithoutCategorie: [],
        unsubscribeGetFeedbackListWithoutCategorie: null,
        subscribedFeedbackListWithoutCategorie: false,
        feedbackListWithoutCategorie: [],
        unsubscribeGetFeedbackListWithoutCategorie: null,
        subscribedFeedbackListWithoutCategorie: false,
        feedbackCategoriesList: [],
        unsubscribeGetFeedbackCategoriesList: null,
        subscribedFeedbackCategoriesList: false,
        feedbackStatusList: [],
        unsubscribeGetFeedbackStatusList: null,
        subscribedFeedbackStatusList: false,
        feedbackEmailList: [],
        unsubscribeGetFeedbackEmailList: null,
        subscribedFeedbackEmailList: false,
    },
    mutations: {
        SET_FEEDBACK_LIST(state, feedbackList) {
            state.feedbackList = feedbackList;
        },
        SET_UNSUBSCRIBE_GET_FEEDBACK_LIST(state, unsubscribe) {
            state.unsubscribeGetFeedbackList = unsubscribe;
            state.subscribedFeedbackList = true
        },
        GO_UNSUBSCRIBE_GET_FEEDBACK_LIST(state) {
            state.unsubscribeGetFeedbackList();
            state.subscribedFeedbackList = false
            state.unsubscribeGetFeedbackList = null
        },
        ADD_FEEDBACK_NOTIFICATION(state, feedbackNotification) {
            state.feedbackNotifications.push(feedbackNotification)
        },
        SET_UNSUBSCRIBE_GET_FEEDBACK_NOTIFICATIONS(state, unsubscribe) {
            state.unsubscribeGetFeedbackNotifications = unsubscribe;
            state.subscribedFeedbackNotifications = true
        },
        GO_UNSUBSCRIBE_GET_FEEDBACK_NOTIFICATIONS(state) {
            state.unsubscribeGetFeedbackNotifications();
            state.subscribedFeedbackNotifications = false
            state.unsubscribeGetFeedbackNotifications = null
        },
        SET_FEEDBACK_LIST_FOR_BADGE(state, feedbackListForBadge) {
            state.feedbackListForBadge = feedbackListForBadge;
        },
        SET_UNSUBSCRIBE_GET_FEEDBACK_LIST_FOR_BADGE(state, unsubscribe) {
            state.unsubscribeGetFeedbackListForBadge = unsubscribe;
            state.subscribedFeedbackListForBadge = true
        },
        GO_UNSUBSCRIBE_GET_FEEDBACK_LIST_FOR_BADGE(state) {
            state.unsubscribeGetFeedbackListForBadge();
            state.subscribedFeedbackListForBadge = false
            state.unsubscribeGetFeedbackListForBadge = null
        },
        SET_FEEDBACK_LIST_WITHOUT_CATEGORIE(state, feedbackListWithoutCategorie) {
            state.feedbackListWithoutCategorie = feedbackListWithoutCategorie;
        },
        SET_UNSUBSCRIBE_GET_FEEDBACK_LIST_WITHOUT_CATEGORIE(state, unsubscribe) {
            state.unsubscribeGetFeedbackListWithoutCategorie = unsubscribe;
            state.subscribedFeedbackListWithoutCategorie = true
        },
        GO_UNSUBSCRIBE_GET_FEEDBACK_LIST_WITHOUT_CATEGORIE(state) {
            state.unsubscribeGetFeedbackListWithoutCategorie();
            state.subscribedFeedbackListWithoutCategorie = false
            state.unsubscribeGetFeedbackListWithoutCategorie = null
        },
        SET_FEEDBACK_CATEGORIES_LIST(state, feedbackCategoriesList) {
            state.feedbackCategoriesList = feedbackCategoriesList;
        },
        SET_UNSUBSCRIBE_GET_FEEDBACK_CATEGORIES_LIST(state, unsubscribe) {
            state.unsubscribeGetFeedbackCategoriesList = unsubscribe;
            state.subscribedFeedbackCategoriesList = true
        },
        GO_UNSUBSCRIBE_GET_FEEDBACK_CATEGORIES_LIST(state) {
            state.unsubscribeGetFeedbackCategoriesList();
            state.subscribedFeedbackCategoriesList = false
            state.unsubscribeGetFeedbackCategoriesList = null
        },
        SET_FEEDBACK_STATUS_LIST(state, feedbackStatusList) {
            state.feedbackStatusList = feedbackStatusList;
        },
        SET_UNSUBSCRIBE_GET_FEEDBACK_STATUS_LIST(state, unsubscribe) {
            state.unsubscribeGetFeedbackStatusList = unsubscribe;
            state.subscribedFeedbackStatusList = true
        },
        GO_UNSUBSCRIBE_GET_FEEDBACK_STATUS_LIST(state) {
            state.unsubscribeGetFeedbackStatusList();
            state.subscribedFeedbackStatusList = false
            state.unsubscribeGetFeedbackStatusList = null
        },
        SET_FEEDBACK_EMAIL_LIST(state, feedbackEmailList) {
            state.feedbackEmailList = feedbackEmailList;
        },
        SET_UNSUBSCRIBE_GET_FEEDBACK_EMAIL_LIST(state, unsubscribe) {
            state.unsubscribeGetFeedbackEmailList = unsubscribe;
            state.subscribedFeedbackEmailList = true
        },
        GO_UNSUBSCRIBE_GET_FEEDBACK_EMAIL_LIST(state) {
            state.unsubscribeGetFeedbackEmailList();
            state.subscribedFeedbackEmailList = false
            state.unsubscribeGetFeedbackEmailList = null
        },
    },
    actions: {
        GetFeedback({}, id) {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await getDoc(doc(db, "feedbacks", id));
                    let feedback = res.data();
                    if (feedback.hasCategorie) {
                        const categorie = await getDoc(feedback.categorie);
                        feedback.categorieObj = categorie.data();
                    }
                    if (feedback.hasStatus) {
                        const status = await getDoc(feedback.status);
                        feedback.statusObj = status.data();
                    }
                    resolve(feedback);
                } catch (error) {
                    reject(error);
                }
            });
        },
        GetFeedbackList({ commit, getters }) {
            return new Promise(async(resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(query(collection(db, "feedbacks"), where('hasCategorie', '==', true), orderBy('createdAt', 'desc')));
                    let feedbackList = [];
                    for (const doc of querySnapshot.docs) {
                        let feedback = doc.data();
                        feedback.id = doc.id;
                        if (feedback.hasCategorie) {
                            const categorie = await getDoc(feedback.categorie);
                            feedback.categorieObj = categorie.data();
                        }
                        if (feedback.hasStatus) {
                            const status = await getDoc(feedback.status);
                            feedback.statusObj = status.data();
                        }
                        feedbackList.push(feedback);
                    }
                    commit("SET_FEEDBACK_LIST", feedbackList);
                    resolve(feedbackList);
                } catch (error) {
                    reject(error);
                }
            });
        },
        GetFeedbackListNextPage({ commit, getters }, itemsPerPage) {
            return new Promise(async(resolve, reject) => {
                commit("GO_UNSUBSCRIBE_GET_FEEDBACK_LIST");
                const q = query(collection(db, "feedbacks"), where('hasCategorie', '==', true), orderBy('createdAt', 'desc'), startAfter(getters.getFeedbackList[getters.getFeedbackListWithoutCategorie.length - 1].createdAt), limit(itemsPerPage));
                let unsubscribe = onSnapshot(q, (querySnapshot) => {
                        let feedbackList = [];
                        querySnapshot.forEach((doc) => {
                            let feedback = doc.data()
                            feedbackList.push(feedback);
                        });
                        if (feedbackList.length > 0) {
                            commit("SET_FEEDBACK_LIST", feedbackList);
                        }
                        resolve(feedbackList);
                    },
                    (error) => {
                        reject(error);
                    }
                );
                commit("SET_UNSUBSCRIBE_GET_FEEDBACK_LIST", unsubscribe);
            });
        },
        GetFeedbackListPrevPage({ commit, getters }, itemsPerPage) {
            return new Promise(async(resolve, reject) => {
                commit("GO_UNSUBSCRIBE_GET_FEEDBACK_LIST");
                const q = query(collection(db, "feedbacks"), orderBy('createdAt', 'asc'), startAfter(getters.getFeedbackList[0].createdAt), limit(itemsPerPage));
                let unsubscribe = onSnapshot(q, (querySnapshot) => {
                        let feedbackList = [];
                        querySnapshot.forEach((doc) => {
                            let feedback = doc.data()
                            feedbackList.push(feedback);
                        });
                        commit("SET_FEEDBACK_LIST", feedbackList);
                        resolve(feedbackList);
                    },
                    (error) => {
                        reject(error);
                    }
                );
                commit("SET_UNSUBSCRIBE_GET_FEEDBACK_LIST", unsubscribe);
            });
        },
        GetFeedbackListWithoutCategoriePaginatedFirstPage({ commit }) {
            return new Promise(async(resolve, reject) => {
                // if(getters.isSubscribedFeedbackListWithoutCategorie){
                //   commit("GO_UNSUBSCRIBE_GET_FEEDBACK_LIST_WITHOUT_CATEGORIE");
                // }
                try {
                    const querySnapshot = await getDocs(query(collection(db, "feedbacks"), where('hasCategorie', '==', false), orderBy('createdAt', 'desc')));
                    let feedbackListWithoutCategorie = [];
                    querySnapshot.forEach((doc) => {
                        let feedback = doc.data();
                        feedback.id = doc.id;
                        feedbackListWithoutCategorie.push(feedback);
                    });
                    commit("SET_FEEDBACK_LIST_WITHOUT_CATEGORIE", feedbackListWithoutCategorie);
                    resolve(feedbackListWithoutCategorie);
                } catch (error) {
                    reject(error);
                }
            })
        },
        GetFeedbackListWithoutCategorieNextPage({ commit, getters }, itemsPerPage) {
            return new Promise(async(resolve, reject) => {
                commit("GO_UNSUBSCRIBE_GET_FEEDBACK_LIST_WITHOUT_CATEGORIE");
                const q = query(collection(db, "feedbacks"), where('hasCategorie', '==', false), orderBy('createdAt', 'desc'), startAfter(getters.getFeedbackListWithoutCategorie[getters.getFeedbackListWithoutCategorie.length - 1].createdAt), limit(itemsPerPage));
                let unsubscribe = onSnapshot(q, (querySnapshot) => {
                        let feedbackListWithoutCategorie = [];
                        querySnapshot.forEach((doc) => {
                            let feedback = doc.data()
                            feedbackListWithoutCategorie.push(feedback);
                        });
                        if (feedbackListWithoutCategorie.length > 0) {
                            commit("SET_FEEDBACK_LIST_WITHOUT_CATEGORIE", feedbackListWithoutCategorie);
                        }
                        resolve(feedbackListWithoutCategorie);
                    },
                    (error) => {
                        reject(error);
                    }
                );
                commit("SET_UNSUBSCRIBE_GET_FEEDBACK_LIST_WITHOUT_CATEGORIE", unsubscribe);
            });
        },
        GetFeedbackListWithoutCategoriePrevPage({ commit, getters }, itemsPerPage) {
            return new Promise(async(resolve, reject) => {
                commit("GO_UNSUBSCRIBE_GET_FEEDBACK_LIST_WITHOUT_CATEGORIE");
                const q = query(collection(db, "feedbacks"), orderBy('createdAt', 'asc'), startAfter(getters.getFeedbackListWithoutCategorie[0].createdAt), limit(itemsPerPage));
                let unsubscribe = onSnapshot(q, (querySnapshot) => {
                        let feedbackListWithoutCategorie = [];
                        querySnapshot.forEach((doc) => {
                            let feedback = doc.data()
                            feedbackListWithoutCategorie.push(feedback);
                        });
                        commit("SET_FEEDBACK_LIST_WITHOUT_CATEGORIE", feedbackListWithoutCategorie);
                        resolve(feedbackListWithoutCategorie);
                    },
                    (error) => {
                        reject(error);
                    }
                );
                commit("SET_UNSUBSCRIBE_GET_FEEDBACK_LIST_WITHOUT_CATEGORIE", unsubscribe);
            });
        },
        GetFeedbackListWithoutCategoriePaginatedFirstPageForBadge({ commit, getters }, itemsPerPage) {
            return new Promise(async(resolve, reject) => {
                if (getters.getFeedbackList.length > 0 && getters.isSubscribedFeedbackListForBadge) {
                    commit("GO_UNSUBSCRIBE_GET_FEEDBACK_LIST_FOR_BADGE");
                }
                const q = query(collection(db, "feedbacks"), where('hasCategorie', '==', false), orderBy('createdAt', 'desc'), limit(itemsPerPage));
                let unsubscribe = onSnapshot(q, (querySnapshot) => {
                        let feedbackListForBadge = [];
                        querySnapshot.forEach((doc) => {
                            let feedback = doc.data()
                            feedback.id = doc.id
                            feedbackListForBadge.push(feedback);
                        });
                        commit("SET_FEEDBACK_LIST_FOR_BADGE", feedbackListForBadge);
                        resolve(feedbackListForBadge);
                    },
                    (error) => {
                        reject(error);
                    }
                );
                commit("SET_UNSUBSCRIBE_GET_FEEDBACK_LIST_FOR_BADGE", unsubscribe);
            });
        },
        GetFeedbackNotifications({ commit }) {
            return new Promise(async(resolve, reject) => {
                const createFunctionCounter = (handlerFunction, invokeBeforeExecution) => {
                    let count = 0;
                    return (snapshot) => {
                        count++;
                        if (count <= invokeBeforeExecution) {
                            return null;
                        }
                        return handlerFunction(snapshot, count);
                    }
                }
                const handleActivitySubscription = (querySnapshot, counter) => {
                    const initialLoad = counter === 1
                    let feedbackListNotifications = [];
                    querySnapshot.docChanges().forEach(async(change) => {
                        let feedback = change.doc.data()
                        feedback.id = change.doc.id
                        feedback.createdAt = moment(feedback.createdAt.toDate()).fromNow()
                        feedbackListNotifications.push(feedback);
                        if (!initialLoad) {
                            if (change.type === "added") {
                                commit('ADD_FEEDBACK_NOTIFICATION', feedback)
                            }
                        }
                    });
                    resolve(feedbackListNotifications);
                }
                const handleActivitySubscriptionWithCounter = createFunctionCounter(handleActivitySubscription, 0);
                const q = query(collection(db, "feedbacks"), orderBy('createdAt'), startAt(new Date()));
                let unsubscribe = onSnapshot(q, handleActivitySubscriptionWithCounter,
                    (error) => {
                        reject(error);
                    }
                );
                commit("SET_UNSUBSCRIBE_GET_FEEDBACK_NOTIFICATIONS", unsubscribe);
            })
        },
        ChangeCategorieOrStatusFeedback({}, data) {
            return new Promise(async(resolve, reject) => {
                if (data.change.categorie) {
                    data.change.categorie = doc(db, 'feedbacksCategories', data.change.categorie)
                } else if (data.change.status) {
                    data.change.status = doc(db, 'feedbacksStatus', data.change.status)
                }
                console.log(data);
                try {
                    await updateDoc(doc(db, "feedbacks", data.feedback), data.change);
                    resolve(data.change);
                } catch (error) {
                    reject(error);
                }
            })

        },
        ResolveFeedback({}, id) {
            return new Promise(async(resolve, reject) => {
                try {
                    await updateDoc(doc(db, "feedbacks", id), {
                        readed: true
                    });
                    resolve(true);
                } catch (error) {
                    reject(error);
                }
            })
        },
        GetFeedbackCategoriesList({ commit }) {
            return new Promise(async(resolve, reject) => {
                let unsubscribe = onSnapshot(collection(db, "feedbacksCategories"), (querySnapshot) => {
                        let feedbackCategoriesList = [];
                        querySnapshot.forEach(async(doc) => {
                            let feedbackCategorie = doc.data()
                            feedbackCategoriesList.push(feedbackCategorie);
                        });
                        commit("SET_FEEDBACK_CATEGORIES_LIST", feedbackCategoriesList);
                        resolve(feedbackCategoriesList);
                    },
                    (error) => {
                        reject(error);
                    });
                commit("SET_UNSUBSCRIBE_GET_FEEDBACK_CATEGORIES_LIST", unsubscribe);
            });
        },
        async CreateFeedbackCategorie({}, feedbackCategorie) {
            return new Promise(async(resolve, reject) => {
                const newDocRef = doc(collection(db, "feedbacksCategories"));
                feedbackCategorie.id = newDocRef.id;
                await setDoc(newDocRef, feedbackCategorie);
                resolve(newDocRef.id);
            })
        },
        GetFeedbackStatusList({ commit }) {
            return new Promise(async(resolve, reject) => {
                let unsubscribe = onSnapshot(collection(db, "feedbacksStatus"), (querySnapshot) => {
                        let feedbackStatusList = [];
                        querySnapshot.forEach(async(doc) => {
                            let feedbackStatus = doc.data()
                            feedbackStatusList.push(feedbackStatus);
                        });
                        commit("SET_FEEDBACK_STATUS_LIST", feedbackStatusList);
                        resolve(feedbackStatusList);
                    },
                    (error) => {
                        reject(error);
                    });
                commit("SET_UNSUBSCRIBE_GET_FEEDBACK_STATUS_LIST", unsubscribe);
            });
        },
        async CreateFeedbackStatus({}, feedbackStatus) {
            return new Promise(async(resolve, reject) => {
                const newDocRef = doc(collection(db, "feedbacksStatus"));
                feedbackStatus.id = newDocRef.id;
                await setDoc(newDocRef, feedbackStatus);
                resolve(newDocRef.id);
            })
        },
        DeleteCategorieOrStatus({}, data) {
            return new Promise(async(resolve, reject) => {
                try {
                    await deleteDoc(doc(db, data.collection, data.id));
                    resolve(data.id);
                } catch (error) {
                    reject(error);
                }
            });
        },
        GetFeedbackEmailList({ commit }) {
            return new Promise(async(resolve, reject) => {
                let unsubscribe = onSnapshot(collection(db, "feedbacksEmails"), (querySnapshot) => {
                        let feedbackEmailList = [];
                        querySnapshot.forEach(async(doc) => {
                            let feedbackEmail = doc.data()
                            feedbackEmailList.push(feedbackEmail);
                        });
                        commit("SET_FEEDBACK_EMAIL_LIST", feedbackEmailList);
                        resolve(feedbackEmailList);
                    },
                    (error) => {
                        reject(error);
                    });
                commit("SET_UNSUBSCRIBE_GET_FEEDBACK_EMAIL_LIST", unsubscribe);
            });
        },
        async AddFeedbackEmail({}, feedbackEmail) {
            return new Promise(async(resolve, reject) => {
                const newDocRef = doc(collection(db, "feedbacksEmails"));
                feedbackEmail.id = newDocRef.id;
                await setDoc(newDocRef, feedbackEmail);
                resolve(newDocRef.id);
            })
        },
        DeleteEmailFromListFeedbacks({}, data) {
            return new Promise(async(resolve, reject) => {
                try {
                    await deleteDoc(doc(db, "feedbacksEmails", data.id));
                    resolve(data.id);
                } catch (error) {
                    reject(error);
                }
            });
        },
        GetFromEmailDefaultFeedback({}) {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await getDoc(doc(db, "feedbacksFromDefaultEmail", 'UsslbyYzy9Y9OYMsztWr'));
                    let feedback = res.data();
                    resolve(feedback);
                } catch (error) {
                    reject(error);
                }
            });
        },
        UpdateFromDefaultEmailFeedback({}, payload) {
            return new Promise((resolve, reject) => {
                Vue.axios
                    .post(requestEndPoint.saveFromAddressFeedback, payload)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            })
        },
        GoUnsuscribeGetFeedbackListWithoutCategorie({ commit }) {
            commit("GO_UNSUBSCRIBE_GET_FEEDBACK_LIST_WITHOUT_CATEGORIE");
        },
        GoUnsuscribeGetFeedbackList({ commit }) {
            commit("GO_UNSUBSCRIBE_GET_FEEDBACK_LIST");
        },
        GoUnsuscribeGetFeedbackListForBadge({ commit }) {
            commit("GO_UNSUBSCRIBE_GET_FEEDBACK_LIST_FOR_BADGE");
        },
        GoUnsuscribeGetFeedbackNotifications({ commit }) {
            commit("GO_UNSUBSCRIBE_GET_FEEDBACK_NOTIFICATIONS");
        },
        GoUnsuscribeGetFeedbackCategoriesList({ commit }) {
            commit("GO_UNSUBSCRIBE_GET_FEEDBACK_CATEGORIES_LIST");
        },
        GoUnsuscribeGetFeedbackStatusList({ commit }) {
            commit("GO_UNSUBSCRIBE_GET_FEEDBACK_STATUS_LIST");
        },
        GoUnsuscribeGetFeedbackEmailList({ commit }) {
            commit("GO_UNSUBSCRIBE_GET_FEEDBACK_EMAIL_LIST");
        },
    },
    getters: {
        getFeedbackList(state) {
            return state.feedbackList;
        },
        isSubscribedFeedbackList(state) {
            return state.subscribedFeedbackList;
        },
        getFeedbackListWithoutCategorie(state) {
            return state.feedbackListWithoutCategorie;
        },
        isSubscribedFeedbackListWithoutCategorie(state) {
            return state.subscribedFeedbackListWithoutCategorie;
        },
        getFeedbackNotifications(state) {
            return state.feedbackNotifications;
        },
        isSubscribedFeedbackNotifications(state) {
            return state.subscribedFeedbackNotifications;
        },
        getFeedbackCategoriesList(state) {
            return state.feedbackCategoriesList
        },
        isSubscribedFeedbackCategoriesList(state) {
            return state.subscribedFeedbackCategoriesList
        },
        getFeedbackStatusList(state) {
            return state.feedbackStatusList
        },
        isSubscribedFeedbackStatusList(state) {
            return state.subscribedFeedbackStatusList
        },
        getFeedbackEmailList(state) {
            return state.feedbackEmailList
        },
        isSubscribedFeedbackEmailList(state) {
            return state.subscribedFeedbackEmailList
        },
        getCountFeedbackWithoutCategorieForBadge(state) {
            if (state && state.feedbackListForBadge && state.feedbackListForBadge.length <= 10) {
                return state.feedbackListForBadge.length
            } else {
                return '+10'
            }
        },
        isSubscribedFeedbackListForBadge(state) {
            return state.subscribedFeedbackListForBadge;
        },
    },
};